import { render, staticRenderFns } from "./ReducedPageHeader.vue?vue&type=template&id=422587bc&scoped=true"
import script from "./ReducedPageHeader.vue?vue&type=script&lang=js"
export * from "./ReducedPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ReducedPageHeader.vue?vue&type=style&index=0&id=422587bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422587bc",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Freduced-page-header%2FReducedPageHeader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports